import {
    Block,
    CHILD_OBJECT_INVALID,
    CHILD_TYPE_INVALID,
    PARENT_OBJECT_INVALID,
    PARENT_TYPE_INVALID,
    Schema,
} from '@gitbook/slate';
import { assert } from '@gitbook/util-ts';

import { BLOCK_PARAGRAPH, BLOCK_STEPPER, BLOCK_STEPPER_STEP } from '../types';
import { unwrapChildren } from '../utils';

/*
 * Schema to validate stepper.
 */
export const schema = Schema.create({
    blocks: {
        [BLOCK_STEPPER]: {
            parent: { objects: ['document', 'block', 'fragment'] },
            nodes: [{ types: [BLOCK_STEPPER_STEP] }],
            isVoid: false,
            normalize: Schema.createNormalize({
                [PARENT_OBJECT_INVALID]: (change, context) => unwrapChildren(change, context.node),
                [PARENT_TYPE_INVALID]: (change, context) => unwrapChildren(change, context.node),
                [CHILD_TYPE_INVALID]: (change, context) => {
                    assert(Block.isBlock(context.node));

                    const stepper = context.node;

                    if (stepper.nodes.size === 1) {
                        return change.removeNodeByKey(stepper.key);
                    }

                    return change.wrapBlockByKey(
                        context.child.key,
                        Block.create({ type: BLOCK_STEPPER_STEP })
                    );
                },
            }),
        },
        [BLOCK_STEPPER_STEP]: {
            parent: { types: [BLOCK_STEPPER] },
            nodes: [{ objects: ['block'] }],
            isVoid: false,
            data: {
                icon: (icon) => icon === undefined || typeof icon === 'string',
            },
            normalize: Schema.createNormalize({
                [PARENT_OBJECT_INVALID]: (change, context) => unwrapChildren(change, context.node),
                [PARENT_TYPE_INVALID]: (change, context) => unwrapChildren(change, context.node),
                [CHILD_OBJECT_INVALID]: (change, context) => {
                    if (context.child.object === 'text') {
                        return change.wrapBlockByKey(
                            context.child.key,
                            Block.create({
                                type: BLOCK_PARAGRAPH,
                            })
                        );
                    }

                    return;
                },
            }),
        },
    },
});
